import React from 'react';
import Loading from "@/components/common/Loading";
import dynamic from "next/dynamic";
import Head from "next/head";

const DesktopPlural = dynamic(() => import("../../components/software-partners/PluralPayments/DesktopPlural"), {
    loading: () => <Loading />,
});

const MobilePlural = dynamic(() => import("../../components/software-partners/PluralPayments/MobilePlural"), {
    loading: () => <Loading />,
});

const PluralPayments = ({ mobileView }) => {
    return (
        <>
            <Head>
                <title>QueueBuster POS with Plural Payments Integration | Secure Payment Solutions</title>
                <meta name="description" content="Integrate QueueBuster POS with Plural Payments for fast, secure, and seamless transactions. Enhance your business efficiency with our advanced payment integration." />
                <link rel="canonical" href="https://queuebuster.co/pos-software-partners/plural-payments" />
                <link rel="alternate" href="https://queuebuster.co/pos-software-partners/plural-payments" hrefLang="en-us" />
                <meta property="og:title" content="QueueBuster POS + Plural Payments: Simplified Payment Processing" />
                <meta property="og:description" content="Experience the ease of QueueBuster POS with Plural Payments integration. Manage secure transactions and optimize your payment processes effortlessly." />
                <meta property="og:image" content="https://quebuster.s3.ap-south-1.amazonaws.com/website/assets/Group+1171276124.png" />
                <meta property="og:url" content="https://queuebuster.co/pos-software-partners/plural-payments" />
            </Head>
            {mobileView ? <MobilePlural /> : <DesktopPlural />}
        </>
    )
}

export default PluralPayments;




 



 
 